<template>

  <!-- Legend buttons -->
  <div :class="['legend-buttons-container',  { show: isHidden }]">
    <el-button id="btn-panel" style="width: 2.4rem; height: 1rem; font-size: 0.5rem" type="success" @click="selectAllLegends">
      <span>All</span>
    </el-button>
    <el-button style="width: 2.4rem; height: 1rem; font-size: 0.5rem; margin-left: -0.1rem" type="warning" @click="deselectAllLegends">
      <span>Clear</span>
    </el-button>
  </div>
  <!-- Legend panel -->
  <div
      :class="['legend-container', { show: isHidden }]"
  >
    <el-checkbox-group id="legend-container-three" v-model="selectedCategory"
                       style="height: 80%; width: 100%;display: flex; flex-direction: column; justify-content: space-between;">
      <div v-for="(category, index) in categoryInfo"
           :key="category.db_category"
           style="height: 100%; display: flex"
           class="legend-block">

        <div style="width: 100%">
          <el-checkbox
              :key="category.db_category"
              :value="category.db_category"
              style="color: white; font-size: 0.4rem; width: 8rem; background-color: #202124; height: 100%"
              border>
            <div style=" height: 100%; display: flex; justify-content: center; /* 水平居中 */ align-items: center; ">
              <div class="inner-div"
                   style="width: 0.833rem; height: 0.833rem; display: inline-block; padding-top: 0.1rem; margin-right: 0.16rem"
                   :id="`legend-obj-${index}`"></div>
              <div style="display: inline-block; font-size: 0.4rem">
                {{ category.short_name ? category.short_name : category.db_category }}
              </div>
            </div>
          </el-checkbox>
          <el-tooltip v-if="category.tooltip" effect="light" :content="category.tooltip" placement="top-end">
            <el-icon color="rgba(255,255,255,0.9)" :size="16" style="padding-left: 0.133rem">
              <InfoFilled/>
            </el-icon>
          </el-tooltip>
        </div>
      </div>
    </el-checkbox-group>
  </div>

  <div id="static-legend-panel" :class="['static-legend-container', { show: isHidden }]"
       style="color: #5a99f9; font-size: 0.467rem">
    <div style="margin-top: 0.167rem; margin-bottom: 0.167rem; font-size: 0.45rem">
      <i>Legend for Shape</i>
    </div>
    <div v-for="(category, index) in nodeShapeInfo"
         :key="category.db_category"
         style="display: flex"
    >
      <div style="display: flex; justify-content: space-between; width: 94%; margin-left: 2%">
        <div class="inner-div"
             style="width: 0.83rem; height: 0.83rem; display: inline-block;"
             :id="`static-legend-obj-${index}`"></div>
        <div class="dashed-connector"></div>
        <p style="display: inline-block; position: relative; margin-bottom: 0.33rem; font-size: 0.4rem">
          {{ category.short_name ? category.short_name : category.db_category }}
        </p>
      </div>
    </div>
  </div>

</template>

<script setup>
import {InfoFilled} from "@element-plus/icons-vue";
import * as THREE from 'three';
import {selectedCategory, edgeMaterial, myGraph} from '../stores/globalStore';
import {createNodeGeometry, colorMap} from '../configs/shapeConfig';
import {onMounted} from "vue";

import {categoryInfo, nodeShapeInfo} from "../configs/legendConfig"

defineProps({
  isHidden: {
    type: Boolean,
    default: false
  }
})


// 全选
function selectAllLegends() {
  selectedCategory.value = categoryInfo.map(item => item.db_category)
}

// 清空
function deselectAllLegends() {
  selectedCategory.value = []
}


// drawLegend 同原代码
function drawLegend() {
  const legendData = {
    renderer: null,
    scene: null,
    camera: null,
    meshes: [],
    animationId: null,
    iconPositions: []
  };

  const mainCanvas = document.createElement('canvas');
  mainCanvas.style.display = 'none';
  document.body.appendChild(mainCanvas);

  const renderer = new THREE.WebGLRenderer({
    canvas: mainCanvas,
    antialias: true,
    alpha: true,
    preserveDrawingBuffer: true
  });
  const scene = new THREE.Scene();
  scene.background = new THREE.Color('#202124');

  const camera = new THREE.PerspectiveCamera(50, 1, 0.1, 1000);
  camera.position.z = 25;

  const ambientLight = new THREE.AmbientLight(0xcccccc, 1.2);
  scene.add(ambientLight);
  const directionalLight = new THREE.DirectionalLight(0xffffff, 1.5);
  scene.add(directionalLight);

  legendData.renderer = renderer;
  legendData.scene = scene;
  legendData.camera = camera;

  categoryInfo.forEach((category, index) => {
    const targetDiv = document.getElementById(`legend-obj-${index}`);
    if (targetDiv) {
      const nodeSize = 8;
      const geometry = createNodeGeometry(category.shape, nodeSize);

      const material = new THREE.MeshPhysicalMaterial({
        color: category.color ? colorMap.get(category.db_category) : 'white',
        side: THREE.FrontSide,
      });

      const mesh = new THREE.Mesh(geometry, material);
      mesh.position.set(0, 0, 0);

      const shapeType = category.shape;
      if (shapeType === 'cube' || shapeType === 'cylinder') {
        mesh.rotation.x = Math.PI / 5;
        mesh.rotation.y = Math.PI / 5;

        const edgesGeometry = new THREE.EdgesGeometry(geometry);
        const edges = new THREE.LineSegments(edgesGeometry, edgeMaterial);
        mesh.add(edges);
      }

      scene.add(mesh);
      legendData.meshes.push(mesh);

      const canvas2d = document.createElement('canvas');
      canvas2d.width = 20;
      canvas2d.height = 20;
      canvas2d.style.width = '0.667rem';
      canvas2d.style.height = '0.667rem';
      canvas2d.style.display = 'inline-block';
      canvas2d.style.verticalAlign = 'top';
      targetDiv.appendChild(canvas2d);

      legendData.iconPositions.push({
        canvas2d: canvas2d,
        mesh: mesh,
        targetDiv: targetDiv
      });
    }
  });

  const animate = () => {
    legendData.animationId = requestAnimationFrame(animate);

    legendData.meshes.forEach(mesh => {
      mesh.rotation.y += 0.02;
    });

    legendData.iconPositions.forEach((iconData, index) => {
      if (iconData.canvas2d && iconData.mesh && iconData.targetDiv.clientWidth > 0) {
        legendData.meshes.forEach((mesh, meshIndex) => {
          mesh.visible = (meshIndex === index);
        });

        const canvasSize = 20;
        renderer.setSize(canvasSize, canvasSize);
        camera.aspect = 1;
        camera.updateProjectionMatrix();

        renderer.render(scene, camera);

        const ctx = iconData.canvas2d.getContext('2d');
        ctx.drawImage(renderer.domElement, 0, 0, canvasSize, canvasSize);
      }
    });

    legendData.meshes.forEach(mesh => {
      mesh.visible = true;
    });
  };

  animate();
  return legendData;
}

function drawStaticLegend() {
  const legendData = {
    renderer: null,
    scene: null,
    camera: null,
    meshes: [],
    animationId: null,
    iconPositions: []
  };

  const mainCanvas = document.createElement('canvas');
  mainCanvas.style.display = 'none';
  document.body.appendChild(mainCanvas);

  const renderer = new THREE.WebGLRenderer({
    canvas: mainCanvas,
    antialias: true,
    alpha: true,
    preserveDrawingBuffer: true
  });
  const scene = new THREE.Scene();
  scene.background = new THREE.Color('#202124');

  const camera = new THREE.PerspectiveCamera(50, 1, 0.1, 1000);
  camera.position.z = 25;

  const ambientLight = new THREE.AmbientLight(0xcccccc, 1.2);
  scene.add(ambientLight);
  const directionalLight = new THREE.DirectionalLight(0xffffff, 1.5);
  scene.add(directionalLight);

  legendData.renderer = renderer;
  legendData.scene = scene;
  legendData.camera = camera;

  nodeShapeInfo.forEach((category, index) => {
    const targetDiv = document.getElementById(`static-legend-obj-${index}`);
    if (targetDiv) {
      const nodeSize = 8;
      const geometry = createNodeGeometry(category.shape, nodeSize);

      const material = new THREE.MeshPhysicalMaterial({
        color: category.color,
        side: THREE.FrontSide,
      });

      const mesh = new THREE.Mesh(geometry, material);
      mesh.position.set(0, 0, 0);

      const shapeType = category.shape;

      if (shapeType !== "sphere") {
        mesh.rotation.x = Math.PI / 5;
        mesh.rotation.y = Math.PI / 5;

        const edgesGeometry = new THREE.EdgesGeometry(geometry);
        const edges = new THREE.LineSegments(edgesGeometry, new THREE.LineBasicMaterial({
          color: 0x5abbf9,
          linewidth: 0.0001,
          opacity: 0.01
        }));
        mesh.add(edges);
      }


      scene.add(mesh);
      legendData.meshes.push(mesh);

      const canvas2d = document.createElement('canvas');
      canvas2d.width = 20;
      canvas2d.height = 20;
      canvas2d.style.width = '0.667rem';
      canvas2d.style.height = '0.667rem';
      canvas2d.style.display = 'inline-block';
      canvas2d.style.verticalAlign = 'top';
      targetDiv.appendChild(canvas2d);

      legendData.iconPositions.push({
        canvas2d: canvas2d,
        mesh: mesh,
        targetDiv: targetDiv
      });
    }
  });

  const animate = () => {
    legendData.animationId = requestAnimationFrame(animate);

    legendData.meshes.forEach(mesh => {
      mesh.rotation.y += 0.02;
    });

    legendData.iconPositions.forEach((iconData, index) => {
      if (iconData.canvas2d && iconData.mesh && iconData.targetDiv.clientWidth > 0) {
        legendData.meshes.forEach((mesh, meshIndex) => {
          mesh.visible = (meshIndex === index);
        });

        const canvasSize = 20;
        renderer.setSize(canvasSize, canvasSize);
        camera.aspect = 1;
        camera.updateProjectionMatrix();

        renderer.render(scene, camera);

        const ctx = iconData.canvas2d.getContext('2d');
        ctx.drawImage(renderer.domElement, 0, 0, canvasSize, canvasSize);
      }
    });

    legendData.meshes.forEach(mesh => {
      mesh.visible = true;
    });
  };

  animate();
  return legendData;
}

// resize
const resizeGraph = () => {
  if (myGraph) {
    myGraph
        .width(document.body.clientWidth)
        .height(document.body.clientHeight)
  }
}

const resizeLegend = (legendData) => {
  if (!legendData || !legendData.renderer) return;
}

onMounted(() => {
  const myLegendData = drawLegend()
  const staticLegend = drawStaticLegend()
  window.onresize = () => {
    resizeGraph();
    resizeLegend(myLegendData);
    resizeLegend(staticLegend);
  }
})

</script>

<style scoped>
/* 按钮容器样式 */
.legend-buttons-container {
  position: fixed;
  right: 0;
  width: 5.33rem;
  top: 0.667rem;
  height: 2rem;
  z-index: 2000; /* 提高层级，盖住 legend */
  background: linear-gradient(90deg, rgba(24, 25, 26, 0.95), rgba(71, 75, 80, 0.95));
  backdrop-filter: blur(10px);
  border-radius: 12px 0 0 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  gap: 0.267rem;
  align-items: center;
  padding: 0 0.533rem;
  border: 1px solid rgba(255, 255, 255, 0.1);

  /* 隐藏时位移到屏幕外 */
  transform: translateX(5.5rem);
  transition: transform 0.3s ease;
}

/* 图例容器样式 */
.legend-container {
  position: fixed;
  right: 0;
  top: 3rem;
  width: 5.33rem;
  height: calc(100vh - 9.33rem);
  z-index: 2000;
  background: linear-gradient(90deg, rgba(24, 25, 26, 0.95), rgba(71, 75, 80, 0.95));
  backdrop-filter: blur(15px);
  border-radius: 0.4rem 0 0 0.4rem;
  box-shadow: -0.267rem 0 1.06rem rgba(0, 0, 0, 0.3);
  overflow: auto;
  border: 0.03rem solid rgba(255, 255, 255, 0.1);
  border-right: none;

  padding-left: -0.066rem;
  /* 隐藏时位移到屏幕外 */
  transform: translateX(5.5rem);
  transition: transform 0.3s ease;
}

/* 静态图例 */
.static-legend-container {
  position: fixed;
  right: 0;
  top: calc(100vh - 6rem);
  width: 5.33rem;
  height: 5.83rem;
  z-index: 2000;
  background: linear-gradient(90deg, rgba(24, 25, 26, 0.95), rgba(71, 75, 80, 0.95));
  backdrop-filter: blur(15px);
  border-radius: 0.4rem 0 0 0.4rem;
  box-shadow: -0.267rem 0 1.06rem rgba(0, 0, 0, 0.3);
  overflow: auto;
  border: 0.03rem solid rgba(255, 255, 255, 0.1);
  border-right: none;


  padding-left: 0.33rem;
  /* 隐藏时位移到屏幕外 */
  transform: translateX(5.5rem);
  transition: transform 0.3s ease;
}

.dashed-connector {
  flex-grow: 1;
  height: 0.033rem;
  border-bottom: 0.033rem dashed #adb5bd;
  margin-top: 0.33rem;
  margin-left: 0.267rem;
  margin-right: 0.267rem;
}

.static-legend-container.show {
  transform: translateX(0);
}

.legend-container.show {
  transform: translateX(0);
}

.legend-buttons-container.show {
  transform: translateX(0);
}

/* 滚动条样式 */
.legend-container::-webkit-scrollbar {
  width: 0.2rem;
  height: 0.2rem;
}

.legend-container::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 0.1rem;
}

.legend-container::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #667eea, #764ba2);
  border-radius: 0.1rem;
}

.legend-container::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #764ba2, #667eea);
}

/* 图例块悬停效果 */
.legend-block {
  transition: all 0.15s ease;
  border-radius: 0.267rem;
  margin: 0.066rem 0.267rem;
  width: 8.4rem;
  padding: 0.267rem;
}

.legend-block:hover {
  background: rgba(255, 255, 255, 0.05);
  transform: translateX(-0.133rem);
}

:deep(.el-checkbox__input) {
  display: none;
}

:deep(.el-checkbox) {
  padding-left: 0;
}

:deep(.el-checkbox__label) {
  padding-left: 0.267rem;
}
</style>
